module.exports = __webpack_public_path__ + "img/Elisha_Rosensweig.35eb68b2.png";